<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/template/point/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shujumoban')">
            <el-select :disabled="templateSelect" filterable :clearable="true" v-model="yt.conditions.templateId">
              <el-option v-for="(item, index) in templateList" :key="index" :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('模板点名称')">
            <el-input v-model="yt.conditions.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mubandianbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shuzhileixing')">
            <yi_dictionary_select  :type="'EQUIPMENT_TEMPLATE_POINT_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({templateId:yt.conditions.templateId,orderBy:'sequence'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
				<!-- 左侧按钮插槽 -->
				<template #buttonsL>
					<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'1200px'),setDefaultValue()" type="primary">
						{{$t('xinzeng')}}
					</el-button>
				</template>
				<!-- 操作插槽 -->
				<template #caozuo="scope">
					<el-row :gutter="10">
						<el-col :span="0.1">
							<el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'1200px'),setDefaultValue()">{{$t('bianji')}}</el-button>
						</el-col>
						<el-col :span="0.1">
							<el-button type="text" class="font-color-danger"
								@click="yt.remove(scope.row,'/web/template/point/delete')">{{$t('shanchu')}}
							</el-button>
						</el-col>
					</el-row>
				</template>
		</yi_curd_table>
			<!-- 新增/编辑弹框 -->
			<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
				:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
				<!-- 新增表单 -->
				<template v-if="yt.editObj.action == 'xinzeng'">
          <div class="dialog-scroller-form">
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item :label="$t('mubandianbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('miaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('fanyi')" required>
                <el-input v-model="yt.editObj.i18n"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shujuleixing')" required>
                <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_DATATYPE'" :ids.sync="yt.editObj.dataType">
                </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('baoliuxiaoshuwei')">
                <el-input v-model="yt.editObj.prec"></el-input>
              </el-form-item>
              <el-form-item :label="$t('danwei')">
                <el-input v-model="yt.editObj.unit"></el-input>
              </el-form-item>
              <el-form-item :label="$t('paixu')" required>
                <el-input v-model="yt.editObj.sequence"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shuzhileixing')" required>
                <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_TYPE'" :ids.sync="yt.editObj.type">
                </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('fenzu')" required>
                <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_GROUP'" :ids.sync="yt.editObj.group">
                </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('laiyuan')">
                <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_SOURCE'" :ids.sync="yt.editObj.source">
                </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('xianshizidian')">
                <el-select filterable :clearable="true" v-model="yt.editObj.dictTypeCode">
                  <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.code"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shifoukexiugai')">
                <el-select v-model="yt.editObj.modifiable">
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('可修改规则')">
                <el-input v-model="yt.editObj.modifiableRule"></el-input>
              </el-form-item>

              <el-form-item :label="$t('xiaxianguize')" >
                <yi_dictionary_select :type="'point_upper_lower_rule_type'" :ids.sync="yt.editObj.lowerRules">
                </yi_dictionary_select>
              </el-form-item>

              <el-form-item :label="$t('morenxiaxian')" >
                <el-input v-model="yt.editObj.lowerDefault"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shangxianguize')">
                <yi_dictionary_select :type="'point_upper_lower_rule_type'" :ids.sync="yt.editObj.upperRules">
                </yi_dictionary_select>
              </el-form-item>

              <el-form-item :label="$t('morenshangxian') " >
                <el-input v-model="yt.editObj.upperDefault"></el-input>
              </el-form-item>

              <el-form-item :label="$t('dangqianduanshu')">
                <el-input v-model="yt.editObj.currentZone"></el-input>
              </el-form-item>

              <el-form-item :label="$t('duanshucode')">
                <el-input v-model="yt.editObj.zoneNumCode"></el-input>
              </el-form-item>

            </el-form>
          </div>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/point/create',beforeAdd)"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
				<!-- 更新表单 -->
				<template v-if="yt.editObj.action == 'bianji'">
            <div class="dialog-scroller-form">
              <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
                <el-form-item :label="$t('mubandianbianma')" required>
                  <el-input disabled v-model="yt.editObj.code"></el-input>
                </el-form-item>
                <el-form-item :label="$t('miaoshu')" required>
                  <el-input v-model="yt.editObj.desc"></el-input>
                </el-form-item>
                <el-form-item :label="$t('fanyi')" required>
                  <el-input v-model="yt.editObj.i18n"></el-input>
                </el-form-item>
                <el-form-item :label="$t('shujuleixing')" required>
                  <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_DATATYPE'" :ids.sync="yt.editObj.dataType">
                  </yi_dictionary_select>
                </el-form-item>
                <el-form-item :label="$t('baoliuxiaoshuwei')">
                  <el-input v-model="yt.editObj.prec"></el-input>
                </el-form-item>
                <el-form-item :label="$t('danwei')">
                  <el-input v-model="yt.editObj.unit"></el-input>
                </el-form-item>
                <el-form-item :label="$t('paixu')" required>
                  <el-input v-model="yt.editObj.sequence"></el-input>
                </el-form-item>
                <el-form-item :label="$t('shuzhileixing')" required>
                  <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_TYPE'" :ids.sync="yt.editObj.type">
                  </yi_dictionary_select>
                </el-form-item>
                <el-form-item :label="$t('fenzu')" required>
                  <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_GROUP'" :ids.sync="yt.editObj.group">
                  </yi_dictionary_select>
                </el-form-item>
                <el-form-item :label="$t('laiyuan')">
                  <yi_dictionary_select :type="'EQUIPMENT_TEMPLATE_POINT_SOURCE'" :ids.sync="yt.editObj.source">
                  </yi_dictionary_select>
                </el-form-item>
                <el-form-item :label="$t('xianshizidian')">
                  <el-select filterable :clearable="true" v-model="yt.editObj.dictTypeCode">
                    <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.code"
                        :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('shifoukexiugai')">
                  <el-select v-model="yt.editObj.modifiable">
                    <el-option :label="$t('shi')" :value="true"></el-option>
                    <el-option :label="$t('fou')" :value="false"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('可修改规则')">
                  <el-input v-model="yt.editObj.modifiableRule"></el-input>
                </el-form-item>
                <el-form-item :label="$t('xiaxianguize')" >
                    <yi_dictionary_select :type="'point_upper_lower_rule_type'" :ids.sync="yt.editObj.lowerRules">
                    </yi_dictionary_select>
                </el-form-item>

                <el-form-item :label="yt.editObj.lowerRules == 'fixed'?$t('morenxiaxian'):$t('morenxiaxian') + 'code'" >
                  <el-input v-model="yt.editObj.lowerDefault"></el-input>
                </el-form-item>
                <el-form-item :label="$t('shangxianguize')">
                    <yi_dictionary_select :type="'point_upper_lower_rule_type'" :ids.sync="yt.editObj.upperRules">
                    </yi_dictionary_select>
                </el-form-item>

                <el-form-item :label="yt.editObj.upperRules == 'fixed'?$t('morenshangxian'):$t('morenshangxian') + 'code'" >
                  <el-input v-model="yt.editObj.upperDefault"></el-input>
                </el-form-item>

                <el-form-item :label="$t('dangqianduanshu')">
                  <el-input v-model="yt.editObj.currentZone"></el-input>
                </el-form-item>

                <el-form-item :label="$t('duanshucode')">
                  <el-input v-model="yt.editObj.zoneNumCode"></el-input>
                </el-form-item>

              </el-form>
            </div>
          <span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/point/update')"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
        </template>
			</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		name: 'admin_data_equipment_template_point',
		data() {
			return {
        dictionaryList: [],
        templateList: [],
        templateSelect: false,
				columns: [{
					label: 'mubandianbianma',
					prop: 'code',
          width: 70,
				}, {
					label: 'miaoshu',
					prop: 'desc',
				}, {
          label: 'fanyi',
          prop: 'i18n',
        }, {
          label: 'shujuleixing',
          prop: 'dataType',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_TEMPLATE_POINT_DATATYPE',
          width: 70,
        }, {
          label: 'baoliuxiaoshuwei',
          prop: 'prec',
          width: 70,
        }, {
          label: 'danwei',
          prop: 'unit',
        }, {
          label: 'paixu',
          prop: 'sequence',
          width: 50,
        }, {
          label: 'shuzhileixing',
          prop: 'type',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_TEMPLATE_POINT_TYPE'
        }, {
          label: 'fenzu',
          prop: 'group',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_GROUP'
        }, {
          label: 'laiyuan',
          prop: 'source',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_SOURCE',
          width: 60,
        },  {
          label: 'xianshizidian',
          prop: 'dictTypeCode',
        },
          {
            label: 'xiaxianguize',
            prop: 'lowerRules',
            type: 'dictionary_tag',
            key: 'point_upper_lower_rule_type',
          },
          {
            label: 'morenxiaxian',
            prop: 'lowerDefault'
          },
        {
          label: 'shangxianguize',
          prop: 'upperRules',
          type: 'dictionary_tag',
          key: 'point_upper_lower_rule_type',
        },
        {
          label: 'morenshangxian',
          prop: 'upperDefault'
        },
        {
          label: 'shifoukexiugai',
          prop: 'modifiable',
          iln18: ['shi', 'fou'],
          width: 70,
          type: 'tag',
          tags: {
            true: {
              color: '#85CE61',
              text: this.$t('shi')
            },
            false: {
              color: '#9254DE',
              text: this.$t('fou')
            }
          }
        },
        {
          label: '可修改规则',
          prop: 'modifiableRule',
        },
        {
          label: 'dangqianduanshu',
          prop: 'currentZone',
          width: 60,
        },
        {
          label: 'duanshucode',
          prop: 'zoneNumCode'
        },

        {
					label: 'caozuo',
					type: 'slot',
					width: 120,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
          templateId: this.$attrs.templateId,
					orderBy:'createTime desc',
				}
        if (this.$attrs.templateId){
          this.templateSelect = true
        }
        this.yt.SELECT_URL = "/web/template/point/getEquipmentTemplatePointByIds"
        this.yt.SELECT_RESULT_KEY = "data"
        this.yt.SELECT_ID = "id"
        this.yt.SELECT_TITLE = "code"
        this.getSelectItemList();
				this.yt.get(1);
        this.utils.event_hub.$on('EQUIPMENT_TEMPLATE_POINT_REFRESH', () => {
          this.yt.get(1);
        })
			}, 300)
		},
		methods: {
      setDefaultValue() {
        if(this.yt.editObj.action === 'xinzeng'){
          this.yt.editObj.modifiable = false;
        }
        if(this.yt.editObj.action === 'bianji' && (this.yt.editObj.modifiable==null || yt.editObj.modifiable == undefined)){
          this.yt.editObj.modifiable = false;
        }
      },
			// 字典值新增
			 beforeAdd(params, url) {
				 params.templateId = this.$attrs.templateId
			 	return params
			 },

      // 获取字典类型
      async getSelectItemList() {
        let dictResponse = await this.http.get('/web/config/dictType/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        let templateResponse = await this.http.get('/web/template/page', {
          params: {
            pageNum: 1,
            pageSize: 10000
          }
        })
        this.dictionaryList = dictResponse.data.rows
        this.templateList = templateResponse.data.rows
      }

		}
	};
</script>


<style>
</style>
